import React from "react"

const Footer = ({ t }) => {
  return (
    <footer className="bg-gray-100 text-gray-600 py-8 border-t border-gray-200">
      <div className="container mx-auto px-6 lg:px-8 text-center">
        <p>&copy; {new Date().getFullYear()} Codegrove. {t.rights}</p>
        <nav className="mt-3 flex flex-wrap justify-center gap-5 text-sm">
          <a className="hover:text-green-700" href="/privacy">
            Privacy
          </a>
          <a className="hover:text-green-700" href="/terms">
            Terms
          </a>
          <a className="hover:text-green-700" href="/hermes/support/">우리집 앱 지원</a>
        </nav>
      </div>
    </footer>
  )
}

export default Footer
